import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor2.png";
import chatify from "../../Assets/Projects/chatify1.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog1.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Events Management System"
              description="This website is build with react.js, Material-UI, Vercel and Firebase.For Event Management, Wedding Planners and Catering Management System ."
              ghLink="https://github.com/prathem5/events-beyontech"
              demoLink="https://events-beyontech.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Beyond Farms"
              description="This website is build with react.js, Material-UI, Vercel and Firebase.For Resort, Hotels, Lounge and Villa's Service Providers"
              ghLink="https://github.com/prathem5/farms-beyondtech"
              demoLink="https://farms-liart.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Hospitality Portfolios"
              description="This website is build with react.js, Material-UI, Vercel and Firebase.For Hospitals and Doctor's portfolio page."
              ghLink="https://github.com/prathem5/DoctorsProfile"
              demoLink="https://doctors-bio.vercel.app/"              
            />
          </Col>  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Om Sai Construction Website"
              description="This website is build with react.js, Material-UI, Vercel and Firebase.For Mr.Suraj Khavale Business Portfolio."
              ghLink="https://github.com/prathem5/"
              demoLink="https://omsaiconstruction.in/"              
            />
          </Col>         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
